import { get } from 'lodash'

import { getSelectedMenusIds } from './config'

export const getCurrentMenuId = (state) => get(state, 'appState.currentMenuId', getSelectedMenusIds(state)[0])

export const getUpdateAvailable = (state) => state?.appState?.updateAvailable ?? false

export const getAutomaticallyUpdate = (state) => state?.appState?.automaticallyUpdate ?? false
